import React from "react";

const steps = [
  {
    title: "Welcome to Bellhopt!",
    description: "Let's walk you through setting up your first property and start getting guest orders.",
  },
  {
    title: "Earn Commission Per Order",
    description: "We use Stripe for payouts and payouts only. To start earning please link or setup your Stripe Account.",
  },
  {
    title: "Add Your Properties",
    description: "Click 'Add Property' on the top right to create a Bellhopt link for your guests. To bulk upload properties please use the Bulk Upload button on the top right of your dashboard.",
  },
  {
    title: "Set up Automated Emails",
    description: "Once all of your properties are added setup Automated Emails within your Property Management Software with your Bellhopt URLs.",
  },
  {
    title: "Schedule a Call",
    description: "Need Further Help? Please Book a call if you have any questions or need assistance with onboarding.",
  },
  {
    title: "You're All Set!",
    description: "That’s it! You can now offer Concierge Services for all your guests and earn per order!",
  },
];

function TutorialModal({ step, onNext, onBack, onClose }) {
  const isLastStep = step === steps.length - 1;
  const isFirstStep = step === 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white w-[90%] max-w-md rounded-xl p-6 shadow-lg relative">
        <h2 className="text-xl font-bold mb-2">{steps[step].title}</h2>
        <p className="text-gray-700 mb-6">{steps[step].description}</p>

        <div className="flex justify-between">
          <button
            onClick={onBack}
            disabled={isFirstStep}
            className={`px-4 py-2 rounded ${isFirstStep ? "bg-gray-300" : "bg-gray-200 hover:bg-gray-300"} text-sm`}
          >
            Back
          </button>
          {!isLastStep ? (
            <button
              onClick={onNext}
              className="bg-primary text-white px-4 py-2 rounded text-sm hover:bg-red-600"
            >
              Next
            </button>
          ) : (
            <button
              onClick={onClose}
              className="bg-primary text-white px-4 py-2 rounded text-sm hover:bg-red-600"
            >
              Finish
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default TutorialModal;
